import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { BookOpen, Clock, Calendar } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-123">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-124">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-125">
          <div className="order-2 lg:order-1 flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-126">
            <FadeIn delay={0.1} data-id="element-127">
              <span className="inline-block py-1 px-3 rounded-full bg-[#E8E0D5] text-[#8B7355] text-sm font-medium tracking-wider uppercase mb-6" data-id="element-128">
                Por: Hoy Pleno
              </span>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-129">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 text-[#8B7355]" data-id="element-130">
                Vuelve a tu Centro
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-131">
              <p className="text-xl md:text-2xl text-[#4A3F35] font-light mb-4" data-id="element-132">
                14 días de calma, enfoque y bienestar
              </p>
              <p className="text-lg text-[#6B5C4D] mb-10 italic" data-id="element-133">
                Un reinicio suave para tu energía y tu mente
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-134">
              <div className="flex flex-col sm:flex-row gap-4 mb-10 w-full sm:w-auto" data-id="element-135">
                <div className="flex items-center gap-2 text-[#6B5C4D] bg-white/50 px-4 py-2 rounded-lg" data-id="element-136">
                  <BookOpen size={18} className="text-[#8B7355]" data-id="element-137" />
                  <span className="text-sm font-medium" data-id="element-138">PDF imprimible</span>
                </div>
                <div className="flex items-center gap-2 text-[#6B5C4D] bg-white/50 px-4 py-2 rounded-lg" data-id="element-139">
                  <Clock size={18} className="text-[#8B7355]" data-id="element-140" />
                  <span className="text-sm font-medium" data-id="element-141">10 min al día</span>
                </div>
                <div className="flex items-center gap-2 text-[#6B5C4D] bg-white/50 px-4 py-2 rounded-lg" data-id="element-142">
                  <Calendar size={18} className="text-[#8B7355]" data-id="element-143" />
                  <span className="text-sm font-medium" data-id="element-144">14 días</span>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.5} data-id="element-145">
              <Button href="#comprar" className="px-10 py-5 text-xl" data-id="element-146">
                Quiero volver a mi centro
              </Button>
            </FadeIn>
          </div>

          <div className="order-1 lg:order-2 flex justify-center lg:justify-end relative" data-id="element-147">
            <FadeIn delay={0.3} direction="left" data-id="element-148">
              <div className="relative w-full max-w-md aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl transform lg:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-149">
                <div className="absolute inset-0 bg-gradient-to-tr from-[#8B7355]/20 to-transparent mix-blend-overlay z-10" data-id="element-150"></div>
                <img src="https://cdn.magicpatterns.com/uploads/e9aYABkT4fasqERGbTPpna/vuelve_a_tu_centro.png" alt="Portada del libro Vuelve a tu Centro" className="w-full h-full object-cover object-center" data-id="element-151" />
              </div>
              {/* Decorative background element */}
              <div className="absolute -inset-4 bg-[#E8E0D5] rounded-full blur-3xl opacity-30 -z-10" data-id="element-152"></div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}